export class AutoSubmitToggleListener {
    public static bindChange(input: HTMLInputElement, onChange: () => void): void {
        input.addEventListener("change", onChange);
    }
}
